/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 11:41:56
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 17:19:06
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/SalesChannelEditorContentSiderConfig.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import { updateSalesChannelContent } from 'src/constrains/SiderErrorController/tools';
import NameWithErr from 'src/constrains/SiderErrorController/SiderNameWithErr';
import { EnumSider, EnumSiderEvent } from 'src/types/common/sider';
import { cancelAllRequests } from 'src/tools/server';
import { useAfterDidMountLanguageChanged } from 'src/constrains/SalesChannelMultiLanguageSelect/hooks';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useSelector } from 'react-redux';
import { WebSiteSubType } from 'src/types/common/SalesChannel';
import { EPermissionSource } from 'src/types/common/resources';
// import { contentDetailPage } from 'src/tools/permissions/salesChannelPermissions';
// import { union } from 'lodash';
import { salesChannelContentEdit } from 'src/tools/permissions/salesChannelSiderPermissions';
import { salesChannelDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';

const icon = ({ type }) => {
  return <Icon type={type} style={iconStyle} />;
};
export const menuArray = (params) => {
  const { saleChannelUuid, contentUuid } = params;
  //const history = useHistory();
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  //_d(updateLanguageList());

  const update = (forceUpdate) => {
    updateSalesChannelContent({
      uuid: saleChannelUuid,
      contentUuid,
      forceUpdate,
    });
  };
  const _update = () => {
    update(true);
  };

  const currentStyle = useSelector(currentSelectedStyle());
  const isResponsive =
    !isMini && currentStyle === WebSiteSubType.ResponsivePage;

  React.useEffect(() => {
    update(false);
    window.addEventListener(EnumSiderEvent.salesChannelContent, _update);
    return () => {
      cancelAllRequests();
      window.removeEventListener(EnumSiderEvent.salesChannelContent, _update);
    };
  }, []);
  useAfterDidMountLanguageChanged(_update); //想象能不能聚集到<SalesChannelWrapper/>里面去，这个wrapper 包裹salesChannel的Layout

  const _name = (name) => [contentUuid, name];

  return [
    {
      path: `/salesChannel/editor/content/homepage/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconhomepage' }),
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.homepage')}
          id={_name(EnumSider.ContentHomePage)}
        />
      ),
      key: 'salesChannelEditorHomepage',
      routers: salesChannelDict.homepage, //['/salesChannel/editor/content/homepage/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    {
      path: `/salesChannel/editor/content/allProductsPage/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconallproductspage' }),
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.allProductsPage')}
          id={_name(EnumSider.AllProductsPage)}
        />
      ),
      key: 'salesChannelEditorAllProductsPage',
      routers: salesChannelDict.allProducts, //['/salesChannel/editor/content/allProductsPage/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    ...(isMini
      ? [
          {
            path: `/salesChannel/editor/content/tabbar/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'icontabbar' }),

            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.tabbar')}
                id={_name(EnumSider.TabBar)}
              />
            ),
            key: 'salesChannelEditorTabBar',
            routers: salesChannelDict.tabBar, //['/salesChannel/editor/content/tabbar/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
        ]
      : [
          {
            path: `/salesChannel/editor/content/404/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'icon404page' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.notFound')}
                id={_name(EnumSider.Page404)}
              />
            ),
            key: 'salesChannelEditor404Page',
            routers: salesChannelDict.page404, //['/salesChannel/editor/content/404/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
        ]),

    // {
    //   path: `/salesChannel/editor/content/maintenance/${saleChannelUuid}/${contentUuid}`,
    //   iconType: icon({ type: 'iconmaintancepage' }),
    //   name: (
    //     <NameWithErr
    //       name={'Maintenance Page'}
    //       id={_name(EnumSider.MaintenancePage)}
    //     />
    //   ),

    //   key: 'salesChannelEditorMaintenancePage',
    //   routers: ['/salesChannel/editor/content/maintenance/*/*'],
    // },
    {
      path: `/salesChannel/editor/content/productSearch/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconlanguageCopy' }),
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.productSearch')}
          id={_name(EnumSider.ProductSearchPage)}
        />
      ),

      key: 'salesChannelEditorProductSearch',
      routers: salesChannelDict.productSearch, //['/salesChannel/editor/content/productSearch/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    {
      path: `/salesChannel/editor/content/contentPage/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconcontentpage' }),
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.contentPage')}
          id={_name(EnumSider.ContentPage)}
        />
      ),
      key: 'salesChannelEditorContentPage',
      routers: salesChannelDict.contentPage,
      // [
      //   '/salesChannel/editor/content/contentPage/*/*',
      //   '/salesChannel/editor/content/contentPage/*/*/*',
      // ],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    {
      path: `/salesChannel/editor/content/shoppingCart/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconshoppingcartpage' }),
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.shoppingCartPage')}
          id={_name(EnumSider.ShoppingCartPage)}
        />
      ),
      key: 'salesChannelEditorShoppingCart',
      routers: salesChannelDict.shoppingCart, //['/salesChannel/editor/content/shoppingCart/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    {
      path: `/salesChannel/editor/content/promotion/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconcampaign' }),
      key: 'salesChannelEditorContentPromotion',
      routers: salesChannelDict.promotion, //['/salesChannel/editor/content/promotion/*/*'],

      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.promotion')}
          id={_name(EnumSider.ContentPromotionPage)}
        />
      ),
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
      //permissionGroup: [EnumPermissions.CANTEST],
    },
    {
      path: `/salesChannel/editor/content/profilepage/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'iconprofilepage' }),

      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.profilePage')}
          id={_name(EnumSider.ContentProfilePage)}
        />
      ),
      key: 'salesChannelEditorProfilePage',
      routers: salesChannelDict.profile, //['/salesChannel/editor/content/profilepage/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    {
      path: `/salesChannel/editor/content/appearance/${saleChannelUuid}/${contentUuid}`,
      iconType: icon({ type: 'icontheme' }),

      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.appearance')}
          id={_name(EnumSider.AppearancePage)}
        />
      ),
      key: 'salesChannelEditorAppearance',
      routers: salesChannelDict.appearance, //['/salesChannel/editor/content/appearance/*/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelContentEdit(params),
    },
    ...(isResponsive
      ? [
          {
            path: `/salesChannel/editor/content/navigation/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'iconlist' }),

            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.navigation')}
                id={_name(EnumSider.Navigation)}
              />
            ),
            key: 'salesChannelEditorNavigation',
            routers: salesChannelDict.navigation, //['/salesChannel/editor/content/navigation/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/header/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'iconpages' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.header')}
                id={_name(EnumSider.Header)}
              />
            ),
            key: 'salesChannelEditorHeader',
            routers: salesChannelDict.header, //['/salesChannel/editor/content/header/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/footer/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'iconlegal' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.footer')}
                id={_name(EnumSider.Footer)}
              />
            ),
            key: 'salesChannelEditorFooter',
            routers: salesChannelDict.footer, //['/salesChannel/editor/content/footer/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/megaMenu/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'icona-megamenu' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.megaMenu')}
                id={_name(EnumSider.MegaMenu)}
              />
            ),
            key: 'salesChannelEditorMegaMenu',
            routers: salesChannelDict.megaMenu, //['/salesChannel/editor/content/megaMenu/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/animation/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'iconanimation' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.animation')}
                id={_name(EnumSider.Animation)}
              />
            ),
            key: 'salesChannelEditorAnimation',
            routers: salesChannelDict.animation,
            // [
            //   '/salesChannel/editor/content/animation/*/*'
            // ],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/button/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'iconbutton' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.button')}
                id={_name(EnumSider.Button)}
              />
            ),
            key: 'salesChannelEditorButton',
            routers: salesChannelDict.button, // ['/salesChannel/editor/content/button/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
          {
            path: `/salesChannel/editor/content/text/${saleChannelUuid}/${contentUuid}`,
            iconType: icon({ type: 'icontext2' }),
            name: (
              <NameWithErr
                name={getI18nFromGeneral('general.sider.textTheme')}
                id={_name(EnumSider.Text)}
              />
            ),
            key: 'salesChannelEditorText',
            routers: salesChannelDict.text, // ['/salesChannel/editor/content/text/*/*'],
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelContentEdit(params),
          },
        ]
      : []),
  ];
};

const iconStyle = {
  color: 'inherit',
  height: '24px',
  width: '24px',
  fontSize: '24px',
};
